export const GetQuizById = /* GraphQL */ `
  query GetForm($documentId: ID!, $email: String!) {
    getFormByEmail(documentId: $documentId, email: $email) {
      form {
        questions {
          documentId
          answerType
          maxSelect
          required
          question {
            json
            html
          }
          options {
            value
            documentId
          }
        }
      }
      submissionStatus {
        isFinished
        message
        notAnsweredQuestions {
          documentId
        }
        questions {
          documentId
          correctAnswers
          answers
          isCorrect
        }
      }
    }
  }
`;
